// /docs/:docId/equations — equation Pass 1 review (PRD 07 §9.4).

import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { EquationsReviewPage } from "../review/equations/EquationsReviewPage";

export const equationsReviewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/docs/$docId/equations",
  component: EquationsReviewRoute,
});

function EquationsReviewRoute() {
  const { docId } = equationsReviewRoute.useParams();
  return <EquationsReviewPage docId={docId} />;
}
